import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';
import { withAuthContext } from 'auth/AuthContext';
import { withMessages } from "react-message-source";
import { supportedLanguages } from 'utils/localizationUtils';

const StyledLangContainer = styled.div`
  margin-top: 15px;
`;

const LanguageDropdown = (props: any) => {

  const {
    language,
    getMessage,
    updateLanguage
  } = props;

  const handleLanguageChange = (e: any, {value}: any) => {
    updateLanguage(value);
  };

  const languageOptions = supportedLanguages.map(lang => ({
    key: lang,
    value: lang,
    text: lang.toUpperCase()
  }));

  return (
      <StyledLangContainer>
        {getMessage("login.changeLanguage")}: {' '}
        <Dropdown
            inline
            options={languageOptions}
            onChange={handleLanguageChange}
            value={language}
            icon='world'
        />
      </StyledLangContainer>
  );
};

export default withAuthContext(withMessages(LanguageDropdown));
